import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { CplaceBooleanControlComponent } from '.';
import { CplaceControlSkeletonModule } from '../cplace-control-skeleton';
import { CplaceControlService } from '../shared/cplace-control.service';

@NgModule({
  declarations: [CplaceBooleanControlComponent],
  imports: [CommonModule, CplaceControlSkeletonModule, CheckboxModule, FormsModule, HttpClientModule],
  exports: [CplaceBooleanControlComponent],
  providers: [CplaceControlService],
})
export class CplaceBooleanControlModule {}
